// extracted by mini-css-extract-plugin
module.exports = {"container":"bouncing-coins-module--container--2ZSgk"};